// extracted by mini-css-extract-plugin
export var externalLink = "_c9-0";
export var internalLinkLabel = "_c9-1";